import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthContext } from "contexts/AuthContext";

import Home from "pages/Home";
import Login from "pages/Auth/Login";
import ErrorNotFound from "pages/ErrorNotFound";
import ProtectedRoute from "routers/ProtectedRoute";
import PublicRoute from "routers/PublicRoute";
import Signup from "pages/Auth/Signup";
import ForgotPassword from "pages/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "pages/Auth/ForgotPassword/ResetPassword";
import Tour from "pages/Tour";

function AppRouter() {
  const authContext = useContext(AuthContext);
  
  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={
            <PublicRoute isAuthenticated={!!authContext.isAuthenticated}>
              <Routes>
                <Route path="" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="*" element={<ErrorNotFound />} />
              </Routes>
            </PublicRoute>
          }
        />
        <Route
          path="/terra-castilla"
          element={
            <ProtectedRoute isAuthenticated={!!authContext.isAuthenticated}>
              <Tour />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default AppRouter;
